<template>
  <div class="table-responsive">
    <table class="table table-bordered table-hover">
      <thead>
        <tr class="bg-black-light">
          <td class="font-medium-1 p-25" colspan="100%">{{ title }}</td>
        </tr>
        <tr>
          <th>Item Description</th>
          <th>UoM</th>
          <th>Total Qty</th>
          <th>Cost %</th>
          <th>Total Cost</th>
          <th>Per Unit Cost</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="items.length">
          <ProductionComponentItem
              @checkQtyUpdate="checkQtyUpdate"
              v-for="(item, i) in items"
              :key="i"
              :item="item"
              :index="i"
              v-show="showOrHideItems(item, i)"
          />
        </template>
        <template v-else>
          <tr>
            <td colspan="4" class="fw-bold text-center">No Data found!</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script setup>

import ProductionComponentItem from "../production/ProductionComponentItem.vue";

const props = defineProps(['items', 'title', 'itemType'])
const emit = defineEmits(['checkQtyUpdate'])
const checkQtyUpdate = (qty) => {
  emit('checkQtyUpdate', qty)
}

const showOrHideItems = (item, index) => {
  const { itemType } = props;

  if (itemType === 'main_product') {
    return item.product_type === 'main_product' || index === 0;
  }

  if (itemType === 'by_product') {
    return item.product_type !== 'main_product' && index !== 0;
  }

  return false;
}

</script>
